import { Grid, styled } from "@mui/material";

export const ContainerWrapper = styled(Grid)`
    padding: 36px;
`;